import { AppScopeLoanReasonsLoaderService } from '../../service/app-scope-loan-reasons-loader.service';
import { AppScopeLoanTypesLoaderService } from '../../service/app-scope-loan-types-loader.service';
import { AppScopeOccupancyTypesLoaderService } from '../../service/app-scope-occupancy-types-loader.service';
import { AppScopePropertyTypesLoaderService } from '../../service/app-scope-property-types-loader.service';
import { CIJobTypesComponent } from '../../ci-job-types/ci-job-types.component';
import { CIJobTypesLoaderService } from '../../ci-job-types/service/ci-job-types-loader.service';
import { CustomHeaderComponent } from '../../components/custom-header/custom-header.component';
import { SoftwareCollectorPackagesComponent } from '../../software-collector-packages/software-collector-packages.component';
import { LenderComponent } from '../../lender/lender.component';
import { LenderLoaderService } from '../../lender/service/lender-loader.service';
import { AppScopeMapperComponent } from '../../components/app-scope-mapper/app-scope-mapper.component';
import { DocumentTypesLoaderService } from '../../service/document-types.loader.service';

const APPSCOPE_CHILDREN_ROUTES =  [
	{
		path: 'property-types',
		component: AppScopeMapperComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Property Types'
			}
		},
		canActivate: [AppScopePropertyTypesLoaderService]
	},
	{
		path: 'loan-types',
		component: AppScopeMapperComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Loan Types'
			}
		},
		canActivate: [AppScopeLoanTypesLoaderService]
	},
	{
		path: 'loan-reasons',
		component: AppScopeMapperComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Loan Reasons'
			}
		},
		canActivate: [AppScopeLoanReasonsLoaderService]
	},
	{
		path: 'occupancy-types',
		component: AppScopeMapperComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Occupancy Types'
			}
		},
		canActivate: [AppScopeOccupancyTypesLoaderService]
	},
	{
		path: 'document-types',
		component: AppScopeMapperComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Document Types'
			}
		},
		canActivate: [DocumentTypesLoaderService]
	}
];

export const LENDERS_CI_INSIDEMAPS_ROUTES= [
	{
		path: 'software-collector-packages',
		component: SoftwareCollectorPackagesComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Software Collector Packages'
			}
		}
	},
	{
		path: 'lender',
		component: LenderComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Lender'
			}
		},
		canActivate: [LenderLoaderService]
	},
	{
		path: 'ci-products',
		component: CIJobTypesComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Class Intelligence Auto Import Products'
			}
		},
		canActivate: [CIJobTypesLoaderService]
	},
];

export const APPSCOPE_ROUTES = [
	{
		path: 'app-scope',
		pathMatch: 'prefix',
		children: APPSCOPE_CHILDREN_ROUTES
	}
];
